import UserProductsSubMenusLinks from "@/components/menu/sub-menus/products/UserProductsSubMenusLinks.vue";
import ProductDetails from "@/components/products/WineComponent.vue";
export default {
  name: "UserWineDetails",
  components: {
    UserProductsSubMenusLinks: UserProductsSubMenusLinks,
    ProductDetails: ProductDetails
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      id: null
    };
  },
  created: function created() {
    this.id = this.$route.params.id;
  }
};